export default __webpack_public_path__ + "static/media/verify-certificate.4abf189b.jpg";